export default function Nav() {
  return (
    <nav className="sticky top-0 z-50 flex items-center justify-between px-6 py-5 border-b border-[#2a2825] bg-[#121110]/90 backdrop-blur-md" data-testid="main-nav">
      <div className="flex items-center gap-3">
        <svg className="w-6 h-6 text-[#c9944a]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
          <path d="M12 2L4 7v10l8 5 8-5V7L12 2z" />
          <path d="M12 22V12" />
          <path d="M12 12L4 7" />
          <path d="M12 12l8-5" />
        </svg>
        <span className="text-sm font-semibold tracking-widest uppercase font-mono-tag text-[#f4efe8]" data-testid="brand-name">Borgo DiVino</span>
      </div>
      <div className="flex items-center gap-6 text-xs uppercase tracking-widest font-mono-tag">
        <a href="#spazi" data-testid="nav-link-spazi" className="hidden md:block text-[#9e968b] hover:text-[#f4efe8] transition-colors">La Casa</a>
        <a href="#posizione" data-testid="nav-link-posizione" className="hidden md:block text-[#9e968b] hover:text-[#f4efe8] transition-colors">Distanze</a>
        <a href="#prenota" data-testid="nav-link-disponibilita" className="px-4 py-2 border border-[#c9944a] text-[#c9944a] hover:bg-[#c9944a] hover:text-[#121110] transition-colors rounded-sm">Disponibilità</a>
      </div>
    </nav>
  );
}
